import { render } from "./Utente.vue?vue&type=template&id=73290201"
import script from "./Utente.vue?vue&type=script&lang=js"
export * from "./Utente.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__